import React from "react";
import shallow from "zustand/shallow";
import { ProductImage } from "../Common/ProductImage";
import { PurchaseItemSummaryPreview } from "./PurchaseItemSummaryPreview";
import { useCreatePurchaseStore } from "@/stores/createPurchaseStore";

export const PurchasePackageSidebarPreview = () => {
    const [product, previewPurchase, activeItemIndex] = useCreatePurchaseStore((state) => {
        return [state.getActiveProduct(), state.purchase, state.activeItemIndex];
    }, shallow);

    return (
        <div className="flex flex-col space-y-0.5 rounded border border-primary bg-primary-lighter p-1">
            <div className="flex items-center space-x-1 pb-1">
                <div className="shrink-0">
                    <ProductImage product={product} size="small" className="!mr-1" />
                </div>

                <h4 className="font-bold">{product.name}</h4>
            </div>

            {previewPurchase?.items.map((item, index) => {
                const isActive = index === activeItemIndex;

                return (
                    <PurchaseItemSummaryPreview
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        isActive={isActive}
                        item={item}
                    />
                );
            })}
        </div>
    );
};
